<template>
  <div class="bgy-table" :class="{ 'bgy-table-auto-height': options.autoHeight }" ref="bgyTable">
    <el-table
      v-bind="$attrs"
      v-on="$listeners"
      :row-key="options.rowKey"
      :data="options.data"
      :height="options.autoHeight ? 'unset' : tableHeight"
      ref="elTable"
    >
      <!-- 普通项 -->
      <template v-for="item in options.columns">
        <!-- 多级表头 -->
        <template v-if="item.columns && item.columns.length">
          <el-table-column :key="item.label" :label="item.label" v-if="item.show === undefined ? true : item.show">
            <template v-for="subItem in item.columns">
              <el-table-column
                v-bind="subItem"
                :key="subItem.prop"
                :sortable="subItem.sort"
                v-if="item.show === undefined ? true : item.show"
                show-overflow-tooltip
                reserve-selection
              >
                <template v-if="subItem.render" v-slot="scope">
                  <Render :row="scope.row" :render="subItem.render" />
                </template>
              </el-table-column>
            </template>
          </el-table-column>
        </template>
        <!-- 一级表头 -->
        <template v-else>
          <el-table-column
            v-bind="item"
            :key="item.prop"
            :sortable="item.sort"
            v-if="item.show === undefined ? true : item.show"
            show-overflow-tooltip
            reserve-selection
          >
            <template v-if="item.render" v-slot="scope">
              <Render :row="scope.row" :index="scope.$index" :render="item.render" />
            </template>
          </el-table-column>
        </template>
      </template>
      <!-- 操作项 -->
      <el-table-column
        v-bind="options.operate"
        v-if="options.actions && options.actions.length"
        class-name="actions-cell"
      >
        <template slot-scope="scope">
          <template v-for="(item, index) in scope.row.actions">
            <template v-if="index < 3">
              <el-link
                :key="item.text"
                :type="item.type || 'primary'"
                :underline="false"
                :disabled="item.disabledFn ? item.disabledFn(scope.row) : false"
                v-if="item.showFn(scope.row) && !(item.tooltipText ? item.tooltipText(scope.row) : false)"
                @click="item.handleFn(scope.row, scope.$index)"
                >{{ item.text }}</el-link
              >

              <el-tooltip :key="item.text" v-else :content="item.tooltipText(scope.row)" popper-class="device-unsynch">
                <el-link
                  :key="item.text"
                  :type="item.type || 'primary'"
                  :underline="false"
                  :disabled="item.disabledFn ? item.disabledFn(scope.row) : false"
                  v-if="item.showFn(scope.row)"
                  @click="item.handleFn(scope.row, scope.$index)"
                  >{{ item.text }}</el-link
                >
              </el-tooltip>
            </template>
          </template>

          <el-popover
            popper-class="table-operate-popper"
            placement="bottom-end"
            trigger="hover"
            v-if="scope.row.actions && scope.row.actions.length > 3"
          >
            <ul class="operate-list-box">
              <template v-for="(item, index) in scope.row.actions">
                <template v-if="index > 2">
                  <li
                    :key="item.text"
                    :class="{ delete: item.type === 'danger' }"
                    v-if="item.showFn(scope.row)"
                    @click="item.handleFn(scope.row, scope.$index)"
                  >
                    <span>{{ item.text }}</span>
                  </li>
                </template>
              </template>
            </ul>
            <span slot="reference" class="more-operate">
              ·<br />
              ·<br />
              ·
            </span>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import Render from './columnRender';

export default {
  name: 'BgyTable',
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  components: {
    Render
  },
  watch: {
    'options.data'() {
      this.handleActions();
    }
  },
  data() {
    return {
      tableHeight: 500,
      actionsData: []
    };
  },
  created() {
    this.handleActions();
  },
  mounted() {
    this.$nextTick(() => {
      this.setTableHeight();
      // 监听窗口大小变化
      window.onresize = () => {
        this.setTableHeight();
      };
    });
  },
  methods: {
    // 设置表格高度
    setTableHeight() {
      let bgyTableHeight = this.$refs.bgyTable.offsetHeight;
      this.tableHeight = bgyTableHeight;
    },
    // 处理操作项
    handleActions() {
      this.options.data.map(item => {
        if (this.options.actions && this.options.actions.length) {
          let actionsData = this.options.actions.filter(action => {
            return action.showFn(item);
          });

          if (actionsData.length) {
            item.actions = actionsData;
          } else {
            item.actions = [
              {
                text: '-',
                type: 'default',
                showFn: () => {
                  return true;
                },
                handleFn: () => {}
              }
            ];
          }
        }
      });
    },
    //取消表格勾选行
    clearSelect() {
      this.$refs.elTable.clearSelection();
    }
  },
  beforeDestroy() {
    window.onresize = null;
  }
};
</script>

<style lang="scss" scoped>
.bgy-table {
  position: relative;
  flex: 1;
  overflow: hidden;

  .el-table {
    position: absolute;
    width: 100%;
    overflow: auto;

    &::before {
      background-color: transparent;
    }

    :deep(th) {
      padding: 8px 0;
      color: #909399;
    }

    :deep(td) {
      padding: 8px 0;
      border-bottom: 1px solid #f2f6fc;
      &.el-table-column--selection .cell {
        padding-right: 10px;
        padding-left: 10px;
      }
    }

    :deep(.el-table__fixed-right::before),
    :deep(.el-table__fixed::before) {
      background-color: transparent;
    }

    :deep(.el-table__fixed-right-patch) {
      background: #fff;
    }

    :deep(.actions-cell) {
      .cell {
        display: flex;
        align-items: center;

        .el-link {
          position: relative;
          padding: 0 10px;

          &:first-of-type {
            padding-left: 0;
          }

          &:last-of-type {
            &::after {
              width: 0;
            }
          }

          &::after {
            content: '';
            position: absolute;
            top: 5px;
            right: 0;
            width: 1px;
            height: 14px;
            background-color: var(--border-table-column);
          }
        }
      }
    }

    :deep(.caret-wrapper) {
      height: 20px;
    }

    :deep(.sort-caret) {
      &.ascending {
        top: -1px;
      }
      &.descending {
        bottom: -1px;
      }
    }
    :deep(.el-table__body-wrapper) {
      &::-webkit-scrollbar {
        width: 16px;
        height: 10px;
        background-color: transparent;
      }
      &::-webkit-scrollbar-track {
        background-color: transparent;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background-color: var(--scroll-bar);
      }
    }
  }

  .more-operate {
    position: relative;
    top: 0;
    display: flex;
    margin-left: 10px;
    line-height: 5px;
    font-size: 12px;
    font-weight: bold;
    color: var(--table-more-operate);
    user-select: none;

    &:hover {
      color: var(--color-primary);
    }

    &::after {
      content: '';
      position: absolute;
      top: -10px;
      right: -10px;
      bottom: -10px;
      left: -10px;
    }
  }
}

.bgy-table-auto-height {
  flex: unset;

  .el-table {
    position: relative;
    overflow: hidden;

    :deep(.el-table__body-wrapper) {
      height: unset !important;
    }
  }
}

.operate-list-box {
  padding: 6px 0;

  li {
    display: flex;
    align-items: center;
    height: 34px;
    padding: 0 15px;

    &:hover {
      cursor: pointer;
      color: var(--color-primary);
      background-color: var(--bg-hover-menu);
    }

    &.delete {
      color: #f15d5d !important;
    }

    &:first-of-type {
      border-top: 0;
    }

    .sc-icon {
      margin-right: 10px;
    }
  }
}
</style>

<style lang="scss">
.table-operate-popper {
  min-width: 86px !important;
  padding: 0 !important;
}
// 文字提示
.el-tooltip__popper.is-dark {
  background: #fff !important;
  border: 1px solid #dcdfe6 !important;
  color: var(--color-text-regular) !important;
  max-width: 400px;
  &[x-placement^='top'] {
    .popper__arrow {
      border-top-color: #dcdfe6 !important;
      &::after {
        border-top-color: #fff !important;
      }
    }
  }
  &[x-placement^='bottom'] {
    .popper__arrow {
      border-bottom-color: #dcdfe6 !important;
      &::after {
        border-bottom-color: #fff !important;
      }
    }
  }
}
</style>
